let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lBPAi")).then(() => parcelRequire('fxoyS'));